// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2937 ? "eabe11fc" : chunkId) + "." + {"156":"36cf7b6ed4b34e1e","2937":"ec3442bf19994070"}[chunkId] + ".js";
};